import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Tag, Modal, Button, message, Breadcrumb, Typography, theme } from "antd";
import axios from "axios";
import { getBackendUrl } from "../../utils/env";

export default function AdminFeedbackDashboard() {
    const { token } = theme.useToken();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFeedback, setSelectedFeedback] = useState(null);

    const fetchFeedback = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${getBackendUrl()}api/admin/getFeedback.php`);
            const feedback = response.data;

            if (Array.isArray(feedback)) {
                setData(feedback);
            } else {
                console.warn("Respuesta inesperada:", feedback);
                setData([]);
                message.warning("Los datos recibidos no tienen el formato esperado.");
            }
        } catch (error) {
            console.error("Error al cargar comentarios:", error);
            message.error("Error al cargar comentarios");
            setData([]); // ← evita que quede en estado inválido
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedback();
    }, []);

    const columns = [
        { title: "Usuario", dataIndex: "user_name" },
        { title: "Email", dataIndex: "email" },
        {
            title: "Tipo",
            dataIndex: "type",
            render: (t) => {
                const labels = {
                    bug: { color: "red", text: "Error o problema" },
                    suggestion: { color: "blue", text: "Sugerencia" },
                    other: { color: "gray", text: "Otro" },
                };
                const tag = labels[t] || { color: "default", text: t };
                return <Tag color={tag.color}>{tag.text}</Tag>;
            },
        },

        { title: "Título", dataIndex: "title" },
        { title: "Fecha", dataIndex: "created_at" },
        {
            title: "Acciones", render: (_, record) => (
                <Button size="small" onClick={() => setSelectedFeedback(record)}>Ver</Button>
            )
        }
    ];

    return (
        <div style={{ padding: 'clamp(16px, 4vw, 32px)', maxWidth: 1200, margin: '0 auto' }}>
            <Breadcrumb
                                    style={{ marginBottom: 24 }}
                                    items={[
                                      {
                                        title: (
                                          <span
                                            onClick={() => navigate("/admin")}
                                            style={{ cursor: "pointer", color: token.colorPrimary }}
                                          >
                                            Panel de Administración
                                          </span>
                                        ),
                                      },
                                      {
                                        title: "Gestión de Comentarios",
                                      },
                                    ]}
                                  />

            <Typography.Title level={2} style={{ marginBottom: 8 }}>
                Comentarios de Usuarios
            </Typography.Title>
            <Typography.Text type="secondary">
                Revisa sugerencias, reportes y mensajes enviados por los participantes.
            </Typography.Text>

            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                loading={loading}
                scroll={{ x: "max-content" }}
                bordered
                size="middle"

            />
            <Modal
                title={`Comentario: ${selectedFeedback?.title}`}
                open={!!selectedFeedback}
                onCancel={() => setSelectedFeedback(null)}
                footer={[
                    <Button key="close" type="primary" onClick={() => setSelectedFeedback(null)}>
                        Cerrar
                    </Button>,
                ]}
            >
                <div style={{ marginBottom: 12 }}>
                    <Typography.Text strong>Usuario:</Typography.Text>{" "}
                    {selectedFeedback?.user_name} ({selectedFeedback?.email})
                </div>
                <div style={{ marginBottom: 12 }}>
                    <Typography.Text strong>Tipo:</Typography.Text>{" "}
                    <Tag color={selectedFeedback?.type === "bug" ? "red" : selectedFeedback?.type === "suggestion" ? "blue" : "gray"}>
                        {selectedFeedback?.type}
                    </Tag>
                </div>
                <div style={{ marginBottom: 12 }}>
                    <Typography.Text strong>Mensaje:</Typography.Text>
                    <div style={{
                        backgroundColor: token.colorFillAlter,
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 4,
                        whiteSpace: "pre-wrap"
                    }}>
                        {selectedFeedback?.message}
                    </div>
                </div>
                <Typography.Text type="secondary">
                    Enviado el {selectedFeedback?.created_at}
                </Typography.Text>
            </Modal>

        </div>
    );
}
